import React from 'react';
import SettingsPageTemplate from '../SettingsPageTemplate';
import PhoneListContainer from './PhoneListContainer';

export default () => (
  <SettingsPageTemplate>
    <PhoneListContainer />
  </SettingsPageTemplate>
);
